<!-- Wrapper -->
<div class="flex flex-col font-semibold relative">
  <!-- No Data Overlay -->
  <!-- <div
    *ngIf="isAllZero"
    class="absolute inset-0 flex items-center justify-center z-20"
  >
    <div class="bg-blue-500 text-white px-6 py-2 rounded-lg shadow-md text-lg">
      No Data Available
    </div>
  </div> -->

  <div
    *ngIf="isAllZero"
    class="w-[80%] absolute shadow-lg rounded-lg p-3 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center z-10 bg-white bg-opacity-95"
  >
    <div class="text-center">
      <mat-icon class="text-gray-400 text-6xl mb-4">visibility_off</mat-icon>
      <h3 class="text-lg font-medium text-gray-900 mb-3 px-16">
        {{ text || "No Records Found" }}
      </h3>
    </div>
  </div>

  <!-- Y-axis + Chart -->
  <div class="flex items-center" [class.hide-content]="isAllZero">
    <div
      *ngIf="chartLabel"
      class="text-md font-semibold mr-2"
      style="writing-mode: vertical-rl; transform: rotate(180deg)"
    >
      {{ chartLabel.yLabel }}
    </div>

    <div
      #chartContainer
      class="flex flex-wrap flex-1 gap-2 rounded-none text-neutral-600 overflow-x-auto"
    >
      <!-- Y-axis -->
      <div
        class="flex flex-col items-start text-xs mt-[10px] whitespace-nowrap"
      >
        <div
          *ngFor="let label of yAxisLabels"
          class="mt-5 first:mt-0 text-[#000]"
        >
          {{ label }}
        </div>
      </div>

      <!-- Bars Section -->
      <div class="overflow-x-auto w-[93%]">
        <div
          class="flex {{
            barAlign
          }} relative gap-5 px-7 py-0.5 whitespace-nowrap min-h-[149px]"
          style="min-width: fit-content"
        >
          <img
            loading="lazy"
            src="/images/dashboard/barchart-background.svg"
            alt=""
            class="object-cover absolute inset-0 size-full"
          />

          <!-- Bars -->
          <div
            *ngFor="let item of data"
            class="flex relative flex-col items-center justify-end mr-3"
            style="width: 40px"
          >
            <div class="text-[11px] mb-1 text-[#000]">{{ item.count }}</div>

            <div
              class="rounded-lg transition-all duration-500"
              [ngClass]="{ 'cursor-pointer': !isAllZero }"
              (click)="onBarClick(item)"
              [ngStyle]="{
                backgroundColor: getBarColor(item.label),
                height: (item.count / maxYValue) * 140 + 'px',
                width: barWidth,
              }"
            ></div>

            <div
              class="text-[11px] mt-1 text-center text-[#000] truncate w-[75px]"
              [matTooltip]="item.label"
              matTooltipPosition="above"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- X-axis Label -->
  <div *ngIf="chartLabel" class="text-md font-semibold text-center mt-2">
    {{ chartLabel.xLabel }}
  </div>
</div>
